module.exports = __webpack_public_path__ + "img/facebook.4e342e78.svg";